<div class="container hlp-width-100">
    <h2 mat-dialog-title style="text-align: center;">Alerta</h2>
    <br>
    <span class="span-txt-justify">
        <p class="hlp-padding-0 hlp-margin-0-10">
            Para prosseguir com a assinatura, é necessário conceder permissão para obter a localização.
            <br>
        </p>
        <p class="hlp-padding-0 hlp-margin-0-10">
            - Siga o passo a passo de acordo com o seu  navegador web ou dispositivo móvel:
        </p>
    </span>

    <br><br>

    <mat-tab-group>
        <mat-tab>
            <ng-template mat-tab-label>
                <img src="./assets/edge-logo.svg" class="icones hlp-margin-0-15" alt="Logo navegador web Microsoft Edge.">
                <img src="./assets/cromada.svg" class="icones hlp-margin-0-15" alt="Logo navegador web Google Chrome.">
            </ng-template>
            <div class="txtCont">
                <span>
                    <p class="hlp-padding-0 hlp-margin-0-2-0-0">
                        <strong>
                            - Navegardores Web: Microsoft Edge ou Google Chrome
                        </strong>
                    </p>
                    <br>
                    <ol class="hlp-padding-0 hlp-margin-0-10">
                        <li>Na barra de navegação, canto superior direito da tela</li>
                        <li>Clique no ícone de marcador de mapas</li>
                        <li>Selecione a opção "Sempre permitir acesso a localização"</li>
                    </ol>
                    <br>
                </span>
                <img src="./assets/gif_google.gif" class="gifs" height="205px" alt="Logo navegador web Google Chrome.">
            </div> 
            <br>
        </mat-tab>

        <mat-tab class="span-txt-left">
            <ng-template mat-tab-label>
                <img src="./assets/firefox-logo.svg" class="icones" alt="Logo navegador web Mozilla Firefox.">
            </ng-template>
            <div class="txtCont">
                <span style="overflow-x: scroll;">
                    <p class="hlp-padding-0 hllp-margin-0-2-0-0">
                        <strong>
                            - Navegardor Web: Mozilla Firefox
                        </strong>
                    </p>
                    <br>
                    <ol class="hlp-padding-0 hlp-margin-0-10">
                        <li>Na barra de navegação, canto superior esquerdo da tela</li>
                        <li>Clique no ícone de marcador de mapas</li>
                        <li>Selecione remova o bloqueio de acesso a localização"</li>
                        <li>Atualize a página</li>
                        <li>Clique em "Memorizar esta decisão"</li>
                        <li>Clique em "Permitir"</li>
                    </ol>
                    <br>
                    <img src="./assets/gif_firefox.gif" width="330px" class="gifs" alt="Logo navegador web Mozilla Firefox.">
                </span>
            </div>
            <br>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <img src="./assets/android.svg" class="icones" alt="Logo sistema Android.">
            </ng-template>
            <br>
            <div class="txtCont">
                <span class="span-txt-left">
                    <p>
                        <strong>
                            - Dispositivo Móvel: Android
                        </strong>
                    </p>
                    <br> 
                    <div>
                        <p class="hlp-padding-0 hlp-margin-0">
                            &nbsp;&nbsp;&nbsp;
                            No aplicativo de navegação do seu dispositivo vai em:
                        </p>
                        <br>
                        <ol class="hlp-padding-0 hlp-margin-0-10">
                            <li>Configurações</li>
                            <li>Configurações do site</li>
                            <li>Local</li>
                            <li>Bloqueado</li>
                            <li>Selecione o site: https://signature-dot-apps-iv2.uc.r.appspot.com</li>
                            <li>Selecione Permitir</li>
                            <li>Atualize a página</li>
                        </ol>
                    </div>
                </span>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>